export default function customForms(options = {}) {
	const { block } = options;

	const container = block.querySelector(".cdb_form_input_container");
	const formEl = container?.querySelector("form") || block.querySelector("form.competition_form");

	const searchRoot = container ?? block;

	if (formEl) {
		formEl.setAttribute("novalidate", "true");

		formEl.addEventListener("submit", (e) => {
			if (formEl.checkValidity()) return;

			e.preventDefault();

			requestAnimationFrame(() => {
				const firstInvalid = searchRoot.querySelector(".cdb_form_field.invalid, ._block_optin.invalid, ._block_terms.invalid");

				if (firstInvalid) {
					firstInvalid.scrollIntoView({
						behavior: "smooth",
						block: "center",
					});

					const field = firstInvalid.querySelector("input, select, textarea");
					field?.focus({
						preventScroll: true
					});
				}
			});
		});

		formEl.addEventListener("invalid", (e) => {
			e.preventDefault();

			if (container?.hasAttribute("data-suppress-invalid")) return;

			const target = e.target;

			if (!(target instanceof HTMLElement)) return;

			const wrap = target.closest(".cdb_form_field") || target.closest("._block_optin") || target.closest("._block_terms") || target.closest(".cdb_form_privacypolicy_information");

			if (wrap) wrap.classList.add("invalid");

		}, true);

		searchRoot.querySelectorAll("._block_optin input[type=checkbox], ._block_terms input[type=checkbox], .cdb_form_privacypolicy_information input[type=checkbox]").forEach((cb) => {
			cb.addEventListener("change", () => {
				if (cb.checked) {
					cb.closest("._block_optin, ._block_terms, .cdb_form_privacypolicy_information",)?.classList.remove("invalid");
				}
			});
		});
	}

	block.querySelectorAll("._block_country_for_optin, ._block_country_select, ._block_intelex_lot_code, ._block_intelex_brand, ._block_intelex_complaint_type, ._block_intelex_product, ._block_intelex_country").forEach((wrapper) => {
			const select = wrapper.querySelector("select");
			if (!select) return;

			if (select.dataset.enhanced) return;
			select.dataset.enhanced = "true";

			const label = wrapper.querySelector("label[data-title]");
			const titleText = label?.getAttribute("data-title") || "";

			const options = [...select.options];

			const customSelect = document.createElement("div");
			customSelect.className = "custom-select";
			customSelect.setAttribute("title", titleText);

			const selected = document.createElement("span");
			selected.className = "custom-selected";
			selected.textContent = select.options[select.selectedIndex]?.text || "Select…";
			if (!select.value) selected.classList.add("is-placeholder");
			customSelect.appendChild(selected);

			const optionList = document.createElement("div");
			optionList.className = "custom-options";

			options.forEach((opt) => {
				const optionDiv = document.createElement("div");
				optionDiv.className = "custom-option";
				optionDiv.textContent = opt.text.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
				optionDiv.dataset.value = opt.value;

				optionDiv.addEventListener("click", (e) => {
					e.stopPropagation();

					select.value = opt.value;

					selected.textContent = opt.text;
					optionList.classList.remove("open");
					customSelect.classList.remove("open");
					wrapper.classList.remove("focused");

					if (!opt.value) {
						selected.classList.add("is-placeholder");
						select.setCustomValidity("This field is required");
					} else {
						selected.classList.remove("is-placeholder");
						select.setCustomValidity("");
						wrapper.classList.remove("invalid");
					}

					select.dispatchEvent(new Event("input", { bubbles: true }));
					select.dispatchEvent(new Event("change", { bubbles: true }));
				});

				optionList.appendChild(optionDiv);
			});

			customSelect.appendChild(optionList);
			wrapper.appendChild(customSelect);
			wrapper.classList.add("has-custom-select");

			selected.addEventListener("click", (e) => {
				e.stopPropagation();
				const isOpen = optionList.classList.toggle("open");
				customSelect.classList.toggle("open", isOpen);
			});

			block.addEventListener("click", (e) => {
				if (!customSelect.contains(e.target)) {
					optionList.classList.remove("open");
					customSelect.classList.remove("open");
					if (!select.value.trim()) {
						wrapper.classList.remove("focused");
					}
				}
			});
		});
}
